module.exports = __webpack_public_path__ + "static/background_main-91d601bbd83b25a7417867772eb78d36.png";